import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UltraHardware.module.scss';
import { centsToDollars } from '../../../lib/util';

interface UltraHardwareProps {
  priceInCents: number;
}

export default function UltraHardware({ priceInCents }: UltraHardwareProps) {
  const { t } = useTranslation();

  const formatPrice = (cents: number) => `$${centsToDollars(cents).replace(/\.00$/, '')}`;

  return (
    <div className={styles.hardwareSection}>
      <h2 className={styles.hardwareTitle}>{t('ultra_hardware')}</h2>
      <div className={styles.hardwareCard}>
        <div className={styles.hardwareName}>{t('ultra_hardware_kit_name')}</div>
        <div className={styles.hardwarePrice}>{formatPrice(priceInCents)}</div>
      </div>
    </div>
  );
}
